module.exports = __webpack_public_path__ + "img/single.40eadbe4.svg";